"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Tooltip = ({ children, position, label, visibleAbove, className, hidden = false, }) => {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(`znd-tooltip znd-tooltip--${position}`, {
            [`znd-tooltip--visible-${visibleAbove}`]: !!visibleAbove,
            [`znd-tooltip--visible`]: !visibleAbove && !hidden,
        }, className) },
        children,
        react_1.default.createElement("div", { className: "znd-tooltip__label" }, label)));
};
exports.default = (0, react_i18next_1.withTranslation)()(Tooltip);
